import { hubConst } from "@app/core";

export function getFlipUrl(id: number, token: string): string {
    return `${hubConst.web.didaticos}open-content/${id}?frame=1&t=${token}&ta=1`
}